import Vue from 'vue'
import Router from 'vue-router'
import {TokenStorage} from "../services/LocalStorage/TokenStorage";

//Pages
import Dashboard from "../views/Dashboard";
import Profile from "../views/Profile";
import Login from "../views/Login";
import Listings from "../views/newsletter/Listings";
import Listing from "../views/newsletter/Listing";
import Person from "../views/person/Person";
import People from "../views/person/People";
import Memberships from "../views/membership/Memberships";
import Membership from "../views/membership/Membership";
import Donations from "../views/donation/Donations";
import Donation from "../views/donation/Donation";
import Users from "../views/users/Users";
import User from "../views/users/User";
import ResetPassword from "../views/users/ResetPassword";
import News from "../views/news/News";
import AddNews from "../views/news/AddNews";
import NewsItem from "../views/news/NewsItem";
import DonationReport from "../views/reports/DonationReport";
import MembershipReport from "../views/reports/MembershipReport";
import ChangePassword from "../views/users/ChangePassword";
import Campaigns from "@/views/newsletter/Campaigns";
import Campaign from "@/views/newsletter/Campaign";
import AddCampaign from "../views/newsletter/AddCampaign";
import Events from "../views/events/Events";
import EventItem from "../views/events/EventItem";

// Containers
const DefaultContainer = () => import('@/containers/DefaultContainer')

Vue.use(Router)

let router = new Router({
  mode: 'hash', // https://router.vuejs.org/api/#modem nnn
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: DefaultContainer,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile,
        },
        {
          path: 'events',
          meta: {label: 'Events'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Events,
            },
            {
              path: ':eventId',
              name: 'event-item',
              meta: {label: 'Event Item'},
              component: EventItem,
            },
          ]
        },
        {
          path: 'news',
          meta: {label: 'News'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: News,
            },
            {
              path: 'add',
              name: 'news-add',
              meta: {label: 'Add News Item'},
              component: AddNews,
            },
            {
              path: ':newsId',
              name: 'news-item',
              meta: {label: 'News Item'},
              component: NewsItem,
            },
          ]
        },
        {
          path: 'membership',
          meta: { label: 'Memberships'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Memberships,
            },
            {
              path: ':memberId',
              meta: { label: 'Membership Details' },
              name: 'member',
              component: Membership,
            }
          ],
        },
        {
          path: 'users',
          meta: { label: 'Users'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Users
            },
            {
              path: ':userId',
              meta: { label: 'User Details' },
              name: 'user',
              component: User,
            }
          ],
        },
        {
          path: 'people',
          meta: { label: 'People'},
          component: {
            render(c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: People,
            },
            {
              path: ':person_id',
              meta: { label: 'Person Details'},
              name: 'person',
              component: Person,
            }
          ]
        },
        {
          path: 'newsletter',
          meta: { label: 'Newsletter'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'listing',
              meta: { label: 'Listings'},
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  component: Listings,
                },
                {
                  path: ':listing_id',
                  meta: { label: 'Listing Details'},
                  name: 'Listing',
                  component: Listing,
                },
              ]
            },
            {
              path: 'campaigns',
              meta: {label: 'Campaigns'},
              component: {
                render (c) { return c('router-view') }
              },
              children: [
                {
                  path: '',
                  component: Campaigns,
                  name: 'Campaigns',
                },
                {
                  path: ':campaignId',
                  component: Campaign,
                  name: 'campaign-item'
                },
                {
                  path: 'add',
                  name: 'add-campaign',
                  meta: { label: 'Add Campaign'},
                  component: AddCampaign,
                }
              ]
            },
          ],
        },
        {
          path: 'donation',
          meta: { label: 'Donations'},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              component: Donations,
            },
            {
              path: ':donationId',
              meta: { label: 'Donation Details'},
              name: 'donation',
              component: Donation,
            },
          ]
        },
        {
          path: 'reports/donations',
          name: 'ReportDonations',
          component: DonationReport,
        },
        {
          path: 'reports/membership',
          name: 'ReportMembership',
          component: MembershipReport,
        },
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword,
    },
    {
      path: '/user/:userId/change-password',
      name: 'UserChangePassword',
      component: ChangePassword,
    },
  ]
})


router.beforeEach(
    (to, from, next) => {
      if (shouldRedirect(to)) {
        next(
          {name: 'Login'}
        )
        return;
      }
      next()
    }
)
function shouldRedirect(to) {
  if ('Login' === to.name) {
    return false;
  }
  if ('ResetPassword' === to.name) {
    return false;
  }

  if ('UserChangePassword' === to.name) {
    return false;
  }
  return !TokenStorage.isAuthenticated();
}

export default router
